module.exports = __webpack_public_path__ + "static/img/1_doll.7554db1f.png";